var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Button from "@irati/ui/src/Button";
import { RouterLink } from "@irati/ui/src/Link";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H1 } from "@irati/ui/src/Typography";
import { SETTINGS_CUSTOMISE_VALUES_VIEW } from "../../../routes/routeConfig";
import SettingsTile from "../SettingsTile";
var CompanyValuesNavigation = /** @class */ (function (_super) {
    __extends(CompanyValuesNavigation, _super);
    function CompanyValuesNavigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyValuesNavigation.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, formatMessage = _a.formatMessage;
        return (React.createElement(React.Fragment, null,
            React.createElement(H1, { marginBottom: 4 }, formatMessage({ id: "admin.companyValues.nav.header" })),
            React.createElement(SettingsTile, { title: "admin.companyValues.tile.manage", value: "admin.companyValues.nav.body" },
                React.createElement(Button, { marginRight: 1, onClick: onClick, small: true },
                    React.createElement(FormattedMessage, { id: "admin.companyValues.nav.create" })),
                React.createElement(RouterLink, { to: SETTINGS_CUSTOMISE_VALUES_VIEW, plain: true },
                    React.createElement(Button, { small: true },
                        React.createElement(FormattedMessage, { id: "admin.companyValues.nav.link" }))))));
    };
    return CompanyValuesNavigation;
}(PureComponent));
export default injectIntl(CompanyValuesNavigation);
